import React from 'react';
import { StyledBreadcrumbs, StyledCurrentBreadcrumb, StyledPreviousBreadcrumb } from './Breadcrumbs.styled';
import arrowRight from "./../../images/arrow_right.png";
import homeIcon from "./../../images/home.svg"
import homeIconWhite from "./../../images/home_white.svg"
import { v4 as uuidv4 } from 'uuid';

export interface BreadcrumbElement {
  title: string;
  description: string;
  toLocation: string;
}

export type Breadcrumbs = BreadcrumbElement[];

interface IBreadcrumbsProps {
  breadCrumbs?: Breadcrumbs
}

export const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({ breadCrumbs }) => {
  return (
    
      <StyledBreadcrumbs>
        {breadCrumbs?.map((breadCrumb: BreadcrumbElement, index: number) => {
          const isLast = index === breadCrumbs.length - 1;
          const isSingle = breadCrumbs.length === 1;
      
          if (isSingle) {
            return (
              <StyledCurrentBreadcrumb key={uuidv4()}>
                <span>{breadCrumb.title}</span>
                <div>
                  <img alt="home" style={{ marginTop: '8px' }} src={homeIconWhite} />
                  {breadCrumb.description}
                </div>
              </StyledCurrentBreadcrumb>
            );
          }
      
          if (!isLast && index !== 0 &&  breadCrumbs.length > 1) {
            return (
              <div style={{ display: 'flex' }} key={uuidv4()}>
                <StyledPreviousBreadcrumb to={breadCrumb.toLocation}>
                  <span>{breadCrumb.title}</span>
                  <div>
                    {breadCrumb.description}
                  </div>
                </StyledPreviousBreadcrumb>
                <div style={{ marginTop: '8px' }}>
                  <img alt="arrow right" src={arrowRight} />
                </div>
              </div>
            );
          }
          if (!isLast && index === 0) {
            return (
              <div style={{ display: 'flex' }} key={uuidv4()}>
                <StyledPreviousBreadcrumb to={breadCrumb.toLocation}>
                  <span>{breadCrumb.title}</span>
                  <div>
                    <img alt="home" src={homeIcon} />
                    {breadCrumb.description}
                  </div>
                </StyledPreviousBreadcrumb>
                <div style={{ marginTop: '8px' }}>
                  <img alt="arrow right" src={arrowRight} />
                </div>
              </div>
            );
          }
      
          return (
            <StyledCurrentBreadcrumb key={uuidv4()}>
              <span>{breadCrumb.title}</span>
              <div>{breadCrumb.description}</div>
            </StyledCurrentBreadcrumb>
          );
        })}
      </StyledBreadcrumbs> 
  )
}
